<template>
  <navigator-home>
    <template>
      <div class="navigator_internal"  v-loading.lock="isLoading">
        <!-- start: title -->
        <div class="title">数据库列表</div>
        <!-- end: title -->

        <!-- start: panel -->
        <div class="panel">
          <div class="panel-left">
            <span class="panel-left-label">数据库所在地域</span>
            <pi-select
              class="panel-left-selector"
              size="mini"
              v-model="currentRegion"
              :options="regionOptions"
              @change="onChangeRegion"
            ></pi-select>
          </div>
          <div class="panel-right">
            <div class="panel-right-search">
              <el-input
                class="panel-right-filter"
                size="mini"
                v-model="filterKeyword"
                placeholder="根据实例名称进行筛选">
              </el-input>
              <el-button size="mini" @click="doSearch" icon="el-icon-search" circle></el-button>
            </div>
            <el-button
              plain
              class="panel-right-refresh"
              size="mini"
              icon="el-icon-refresh"
              @click="onRefresh">
            </el-button>
          </div>
        </div>
        <!-- end: panel -->
        <!-- start: table -->
        <div class="table-container">
          <h3c-server-table style="width: 100%"
            :url="tableUrl"
            :v-loading="tableLoading"
            ref="tableObj"
            :auto-refresh="true"
            stripe
            :header-cell-style="{ backgroundColor: '#e6e8ec' }"
            :cell-style="{ 'font-size': '12px' }">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="实例名称/实例ID" min-width="144px">
              <template scope="scope">
                <div class="table-instance_name">{{ scope.row.Name }}</div>
                <div class="table-instance_id">{{ scope.row.Uuid }}</div>
              </template>
            </el-table-column>
            <el-table-column label="实例规格">
              <template scope="scope">
                <div v-if="scope.row.ServiceType === 'redis'">{{ scope.row.DbMemory*scope.row.NodeCount }}GB
                  {{scope.row.ServiceEdition === 'SE' ? '' : `(共${scope.row.NodeCount}节点)`}}</div>
                <div v-else>{{ scope.row.CpuCount }}核{{ scope.row.DbMemory }}GB</div>
              </template>
            </el-table-column>
            <el-table-column
              label="数据库类型"
              prop="ServiceType"
              :filters="[{text:'mysql',value:'mysql'},{text:'mongodb',value:'mongodb'},{text:'redis',value:'redis'}]"
              :filter-multiple="false"
              :filtered-value="[]"
              show-overflow-tooltip>
              <template scope="scope">
                <span :style="{ color: scope.row.ServiceType === 'Unknown' ? '#f56c6c' : '#606266' }">
                  {{scope.row.ServiceType}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="数据库版本" prop="ServiceEdition">
              <template scope="scope">
                <div>{{ edition(scope.row.ServiceEdition, scope.row.ServiceType) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="运行状态">
              <template scope="scope">
              <span :style="{ color: (scope.row.StatusDescription === 'running' || scope.row.StatusDescription === 'restart required') ? '#67c23a' : '#f56c6c' }">{{
                (scope.row.StatusDescription === 'running' || scope.row.StatusDescription === 'restart required') ? '运行中' : '异常'
              }}</span>
              </template>
            </el-table-column>
            <el-table-column label="开通时间/到期时间">
              <template scope="scope">
                <div>{{ scope.row.CreateTime }}</div>
                <div>{{ scope.row.EndTime }}</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="144px">
              <template scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="(scope.row.StatusDescription !== 'running' && scope.row.StatusDescription !== 'restart required')"
                  @click="onLogin(scope)"
                >登录数据库</el-button
                >
              </template>
            </el-table-column>
          </h3c-server-table>
        </div>
        <!-- end: table -->
      </div>
    </template>
  </navigator-home>
</template>

<script>
import FilterTableData from './filter-table-data';
import NavigatorHome from './NavigatorHome';
import { reqFetchRegions } from '@/api/source';
import h3cServerTable from '../common/h3c-server-table.vue';

export default {
  name: 'NavigatorInternal',

  components: {
    NavigatorHome,
    'h3c-server-table': h3cServerTable,
  },

  mixins: [FilterTableData],

  data() {
    return {
      isLoading: false,
      currentRegion: '',
      regions: [],
      regionOptions: [],
      tableData: [],
      fieldForFilter: 'db_instance_name',
      needWakeLogin: false,
      tableLoading: false
    };
  },

  computed: {
    /**
     * 当前选中的地域信息
     */
    calcCurrentRegionInfo() {
      return this.regions.find(region => region.id === this.currentRegion);
    },
    tableUrl() {
      if(this.currentRegion){
        return '/v1/self/listsInstance?RegionId=' + this.currentRegion;
      }
      return '';
    }
  },

  async created() {
    this.isLoading = true;
    try {
      // 获取地域列表
      await this.getRegionOptions();

      // 如果 url 中直接携带了 instanceId，并且该 id 有效，则查找该实例对应的地域并激活
      // 反之则设置地域列表中的第一个为选中
      const routeQuery = this.$route.query;
      if (routeQuery.instanceID && routeQuery.cloudID) {
        this.currentRegion = routeQuery.cloudID;
        this.needWakeLogin = true;
      } else {
        this.currentRegion = this.regionOptions[0].value;
        this.needWakeLogin = false;
      }
    } catch (e) {
      let message;
      if (e instanceof Error) {
        message = e.message;
      } else if (e instanceof String) {
        message = e;
      } else {
        message = '初始化实例失败列表，请稍候重试';
      }

      this.$message.error(message);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    edition(ServiceEdition, ServiceType){
      if(ServiceEdition === 'EE') {
          return '集群版';
      } else if (ServiceEdition === 'SE') {
        if(ServiceType === 'mongodb') {
          return '单节点';
        } else {
          return '基础版';
        }
      } else if (ServiceEdition === 'HA') {
        if(ServiceType === 'mongodb') {
          return '多副本集';
        } else {
          return '高可用版';
        }
      }
    },
    async getRegionOptions() {
      try {
        const res = await reqFetchRegions();
        // 记录地域信息
        this.regions = res.data.data;
        // 生成地域选项
        this.regions.map(region =>{
          let obj = {
            label: region.name,
            value: region.id
          };
          this.regionOptions.push(obj);
        });
      } catch (e) {
        throw new Error('获取地域列表失败');
      }
    },

    onRefresh() {
      this.filterKeyword = '';
      /*this.$refs.tableObj.searchTable();
      this.searchText = '';*/
      this.$refs.tableObj.resetSearchTable();
      //this.getDatabases(this.currentRegion);
    },
    onLogin({ row }) {
      const { href } = this.$router.resolve({
        name: 'Login',
        query: {
          RegionId: this.currentRegion,
          instanceName: row.Name,
          InstanceId: row.Uuid,
          ServicePort: row.ServicePort,
          ServiceType: row.ServiceType,
          ServiceEdition: row.ServiceEdition
        }
      });
      window.open(href);
    },
    filterDbType(value, row){
      return row.dbType === value;
    },
    doSearch(){
      if(this.filterKeyword)
      {
        this.$refs.tableObj.searchTable('Name', this.filterKeyword);
      }
    },
    onChangeRegion(){
      // this.$refs.tableObj.resetPage();
      // this.onRefresh();
    }
  }
};
</script>

<style scoped lang="scss">
.navigator_internal {
  padding: 8px 36px;

  .title {
    margin: 0 0 0 -12px;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 0 0;
  }

  .panel {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;

      &-label {
        font-size: 13px;
        color: #444;
        margin-right: 10px;
      }
    }

    &-right {
      display: flex;
      align-items: center;

      &-search {
        position: relative;
        display: inline-block;
        button {
          /*width: 28px;
          height: 28px;*/
          position: absolute;
          right: 1px;
          top: 1px;
          border: none;
          background: #fff
        }
        button:hover {
          background: #fff
        }
      }

      &-selector {
        width: 200px;
      }

      &-filter {
        width: 200px;
        margin-left: 5px;
      }

      &-refresh {
        margin-left: 5px;
      }
    }
  }

  .table-container{
    margin-top: 20px;
  }

  .table {
    margin-top: 16px;

    &-instance_name {
      color: #000;
    }

    &-instance_id {
      color: $g-color-primary;
    }
  }
}
</style>
